import { API } from "../API";
import { EventSource } from "./EventSource";

// uses design pattern under header "Difference between the static and instance sides of classes" in link:
// https://www.typescriptlang.org/docs/handbook/interfaces.html

export interface RealTimeManager {
  /**
   * completely close and disable the manager.
   */
  close: () => void;

  /**
   * Force a disconnect from Real Time system. Could be called when the app has been put in the background.
   *
   * The [[onDisconnected]] event will be fired.
   */
  disconnect: () => void;

  /**
   * Reconnect after a call to [[disconnect]].
   *
   * After the connection is re-established, the [[onConnected]] event will be fired.
   */
  reconnect: () => void;

  addListener: (eventName: string, listener: (payload: any) => void) => void;

  /**
   * Will be fired after the initial connection has been established,
   * and also after reconnecting after a disconnect event.
   */
  onConnected: EventSource<void>;

  /**
   * Will be fired when the connection has become broken
   */
  onDisconnected: EventSource<void>;
}

export type RealTimeManagerConstructor = new (
  api: API,
  listenersMap: Map<string, (payload: any) => void>
) => RealTimeManager;

export function createRealTimeManager(
  ctor: RealTimeManagerConstructor,
  api: API,
  listenersMap: Map<string, (payload: any) => void>
): RealTimeManager {
  return new ctor(api, listenersMap);
}
